import Button from "common/Buttons/Button.tsx";
import { BASE_BILLING_SETTINGS_PATH } from "common/constants.ts";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { CancelSubscriptionContext } from "@shared/features/settings/subscription/CancelSubscription.context.ts";
import styled, { css } from "styled-components";
import { STICKY_FOOTER_LAYOUT_MIN_WIDTH } from "features/settings/CancelSubscription/constants.ts";
import { CancellationStep } from "@shared/features/settings/subscription/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

const Footer = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const history = useHistory();
  const {
    onNextClick,
    isLoadingCancelSubscription,
    reason,
    step,
    isInvalidReasonDescription,
  } = useContext(CancelSubscriptionContext)!;
  const isLoseDiscountStep = step === CancellationStep.LOSE_DISCOUNT;
  const isAreYouSure = step === CancellationStep.ARE_YOU_SURE;
  const disabled =
    step === CancellationStep.REASON && (!reason || isInvalidReasonDescription);

  if (step === CancellationStep.SUCCESS) return null;

  return (
    <FooterWrapper $center={isAreYouSure}>
      <StyledButton
        type="primary"
        onClick={() => history.push(BASE_BILLING_SETTINGS_PATH)}
      >
        {isLoseDiscountStep
          ? t("cancel_subscription.keep_discount")
          : t("cancel_subscription.keep_auto_renewal")}
      </StyledButton>
      <StyledButton
        danger
        onClick={onNextClick}
        loading={isLoadingCancelSubscription}
        disabled={disabled}
      >
        {isLoseDiscountStep
          ? t("cancel_subscription.want_to_cancel")
          : t("cancel_subscription.cancel_auto_renewal")}
      </StyledButton>
    </FooterWrapper>
  );
};

export default Footer;

const FooterWrapper = styled.div<{
  $center?: boolean;
}>`
  display: flex;
  column-gap: 8px;
  align-items: center;
  margin-top: 24px;
  @media (max-width: 359.98px) {
    flex-wrap: wrap;
    row-gap: 8px;
  }
  @media (max-width: ${STICKY_FOOTER_LAYOUT_MIN_WIDTH}px) {
    justify-content: space-between;
    background-color: ${(p) => p.theme.colors.layoutBgColor};
    border-top: ${(p) => p.theme.borders.light};
    padding: 12px;
    margin-top: 0;
  }
  @media (min-width: ${STICKY_FOOTER_LAYOUT_MIN_WIDTH}px) {
    ${(p) =>
      p.$center &&
      `
    justify-content: center;
  `};
  }
  ${(p) =>
    p.theme.isNewLook &&
    css`
      margin-top: 16px;
      @media (min-width: ${STICKY_FOOTER_LAYOUT_MIN_WIDTH}px) {
        justify-content: flex-end;
      }
      @media (max-width: ${STICKY_FOOTER_LAYOUT_MIN_WIDTH}px) {
        margin-top: 0;
        padding: 12px 16px;
        border-top: ${p.theme.borders.card};
        .ant-btn {
          flex: 1;
        }
      }
    `}
`;
const StyledButton = styled(Button)`
  @media (max-width: 370px) {
    font-size: 12px;
  }
`;
